import axios from 'axios'

export default {
  async getItemSkuAddressInputDescriptionHtml(itemId, itemSkuId) {
    const response = await axios.get(
      `/api/v1/pickup/items/${itemId}/item_skus/${itemSkuId}`
    )
    return response.data.data.attributes.addressInputDescriptionHtml
  }
}
